import * as Yup from 'yup';

/**
 * Validation schema for creating a new TS plus license.
 * @constant
 * @type {object}
 * @property {Yup.StringSchema} computerId
 * @property {Yup.StringSchema} license
 * @property {Yup.StringSchema} officeName
 * @property {Yup.NumberSchema} numOfUsers
 * @property {Yup.NumberSchema} computerDetails
 * @property {Yup.DateSchema} startDate
 * @property {Yup.DateSchema} expireDate
 */

const createLicenseValidation = Yup.object({
    computerId: Yup.string()
        .transform((v, ov) => (ov === '' ? null : v))
        .nullable(),
    license: Yup.string()
        .required('Required')
        .trim('Remove any leading or trailing spaces')
        .uppercase(),
    numOfUsers: Yup.number().required('Required').integer().positive(),
    createDate: Yup.date()
        .transform((value, originalValue) =>
            originalValue === '' ? null : value
        )
        .typeError('Invalid date')
        .nullable()
        .required('Required'),
    errorFlag: Yup.boolean().default(false)
    // startDate: Yup.date().required('Required'),
    // expireDate: Yup.date().required('Required')
    // officeName: Yup.string()
    //     .required('Office Name is required')
    //     .trim()
    //     .uppercase(),
    // computerDetails: Yup.number()
    //     .required('Computer Details are required')
    //     .integer()
    //     .positive()
});

export default createLicenseValidation;
